import React from "react";
import Box from "./Box";
import Image from "./Image";
import Text from "./Text";

function BrandHomepageHeader({ brand }) {
  return (
    <Box
      height={[190, null, 540, null]}
      position="relative"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bg="lightGrey"
    >
      {brand.headerImage && (
        <Image
          src={brand.headerImage.url}
          alt={brand.name}
          objectFit="cover"
          sizes="100vw"
          zIndex={1}
          display={
            brand.mobileHeaderImage ? ["none", "block", null, null] : "block"
          }
        />
      )}
      {brand.mobileHeaderImage && (
        <Image
          src={brand.mobileHeaderImage.url}
          alt={brand.name}
          objectFit="cover"
          sizes="100vw"
          zIndex={1}
          display={["block", "none", null, null]}
        />
      )}
      <Box
        position="relative"
        zIndex={2}
        bg="black"
        py={18}
        px={22}
        m={["2px", null, "5px", null]}
      >
        <Text
          as="h1"
          uppercase
          fontSize={[30, 30, 62, 62]}
          color="white"
          lineHeight={1}
          textAlign="center"
        >
          {brand.name}
        </Text>
      </Box>
    </Box>
  );
}

export default BrandHomepageHeader;
